<template>
	<div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
		<div class="carousel">
			案例精选
		</div>
		<div class="case_main">
			<div class="case_top">
				<div class="case_title">旺能智能管控系统</div>
				<div class="case_time">
					<img src="../../assets/images/developerCommunity/dev_time.png" alt="">
					<span>2020/06/12</span>
				</div>
				<hr>
			</div>
			<div class="case_detail">
				<div class="model">
					<div class="model_title">【企业介绍】</div>
					<div class="section">
						旺能环境股份有限公司总部位于“两山”理念发源地——浙江湖州，是专业从事生活垃圾、餐厨垃圾、市政污泥等固体废弃物综合处置的环保产业公司，连续六年居全国固废行业十强。
					</div>
					<div class="section">
						旺能环保实现生活垃圾“减量化、资源化、无害化”处置，服务属地生态文明建设发挥重要作用。公司已在全国多个地市建设静脉产业园项目，其中许昌项目还获得中国人居环境范例奖。
					</div>
				</div>
				<div class="model">
					<div class="model_title">【项目概况】</div>
					<div class="section">
						<img src="../../assets/images/detail_pic1.png" alt="">
					</div>
					<div class="section">
						项目总投资1.4亿元,总规模400t/d,其中餐饮垃圾200t/d,厨余垃圾200t/d,同时配套有相应污泥处置。在工艺路线上,采取独立预处理+联合厌氧发酵+沼气发电工艺。现建有一个预处理生产车间,和两条预处理生产线,这两条生产线为一条100吨的餐饮线+200吨的厨余预处理线,预留一条100吨的餐饮线和2座2500立方米的厌氧发酵罐。通过配套收运系统、污水处理系统、除臭系统、沼气净化系统和燃烧发电系统实现餐厨垃圾资源化利用和无害化处置的效果。在整体设计上,项目也充分融合湖州市当地建筑文化,体现出江南水乡的建筑特色,实现了建筑设计与工艺设计的完美结合。
					</div>
				</div>
				<div class="model">
					<div class="model_title">【项目效果】</div>
					<div class="section">
						整合集团各项目生产运营数据，生成可视化数据分析图表，进行可视化集中管控，通过大屏可以直观的了解到集团各项目的整体运行状况。从生产效益分析和产气分析可以了解到厂区的计划与完成情况。而能耗分析和报警分析则展示了各工艺单元之间的能耗对比。让管理者对产业链运行的总体指标进行把控，有利于项目以及运营团队之间的横向对比，为总体运营战略的制定提供数据服务及决策支撑
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'CaseDetail',
		data() {
			return {
				detailId: this.$route.params.id,
			}
		},
		mounted() {
			window.scrollTo(0, 0)
			this.init()
		},
		methods: {
			init() {
				console.log(this.detailId)
			}
		}
	}
</script>

<style lang="scss">
	.carousel {
		background-color: #1a1a1a;
		height: 4rem;
		text-align: center;
		line-height: 4rem;
		font-size: 0.4rem;
		color: #FFFFFF;
	}

	.case_main {

		padding: 0 2.4rem;
		margin-bottom: 0.3rem;

		.case_top {
			margin-top: 0.6rem;

			.case_title {
				font-size: 0.32rem;
			}

			.case_time {
				margin-top: 0.2rem;
				font-size: 0.18rem;
				color: #999999;
				display: flex;
				align-items: center;
				img {
					width: 0.2rem;
					height: 0.2rem;
					margin-right: 0.1rem;
				}
			}

			hr {
				margin-top: 0.4rem;
				color: #cccccc;
			}
		}

		.case_detail {
			margin: 0 2.2rem;
			margin-bottom: 0.6rem;
			color: #000000;
			img {
				width: 100%;
			}
			.model{
				margin-top: 0.2rem;
				.model_title{
					font-size: 0.22rem;
					font-weight: 600;
				}
				.section{
					padding-left: 0.12rem;
					text-indent: 2em;
					line-height: 0.36rem;
					font-size: 0.18rem;
					margin-top: 0.12rem;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseDetail.vue